import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6765b182")

_pushScopeId("data-v-6765b182")
const _hoisted_1 = { class: "SelectedDateRange" }
const _hoisted_2 = {
  key: 0,
  class: "SelectedDateRange__block"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "block__subtext" }, "Дата от", -1)
const _hoisted_4 = { class: "block__date" }
const _hoisted_5 = { class: "date__number" }
const _hoisted_6 = { class: "date__month" }
const _hoisted_7 = {
  key: 1,
  class: "SelectedDateRange__block"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "block__subtext" }, "Дата до", -1)
const _hoisted_9 = { class: "block__date" }
const _hoisted_10 = { class: "date__number" }
const _hoisted_11 = { class: "date__month" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_ellipse_one = _resolveComponent("icon-ellipse-one")!
  const _component_icon_ellipse_two = _resolveComponent("icon-ellipse-two")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.range && _ctx.range.date_from)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_icon_ellipse_one, { class: "block__ellipse" }),
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.range.date_from.getDate()), 1),
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.getMonthName(_ctx.range.date_from.getMonth())), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.range && _ctx.range.date_to)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode(_component_icon_ellipse_two, { class: "block__ellipse" }),
          _hoisted_8,
          _createVNode("div", _hoisted_9, [
            _createVNode("span", _hoisted_10, _toDisplayString(_ctx.range.date_to.getDate()), 1),
            _createVNode("span", _hoisted_11, _toDisplayString(_ctx.getMonthName(_ctx.range.date_to.getMonth())), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})